import React from 'react'
import PropTypes from 'prop-types'

const Title = ({
  handleSideFilterMenuCollapseChange = () => {},
  sideFilterVisible = false,
  translate = () => {},
}) => (
  <div
    style={{
      float: 'left',
      marginTop: '1rem',
      paddingLeft: `${sideFilterVisible ? '24' : '0'}.5rem`,
    }}
  >
    <button
      className={`filter-button ${
        sideFilterVisible ? '' : 'margin-left'
      } title`}
      onClick={() => handleSideFilterMenuCollapseChange(!sideFilterVisible)}
    >
      <i
        className={`glyph glyph-double-arrow-${
          sideFilterVisible ? 'left' : 'right'
        } glyph-grey icon-size`}
      />
      {translate('mobile.filters')}
    </button>
  </div>
)

Title.propTypes = {
  handleSideFilterMenuCollapseChange: PropTypes.func,
  sideFilterVisible: PropTypes.bool,
  translate: PropTypes.func,
}

export default Title
